// 버전 체크 유틸리티

const VERSION_STORAGE_KEY = 'app_version_info';
const VERSION_CHECK_INTERVAL = 30000; // 30초

/**
 * 로컬 스토리지에서 현재 버전 정보 가져오기
 */
export function getLocalVersion() {
  try {
    const versionStr = localStorage.getItem(VERSION_STORAGE_KEY);
    return versionStr ? JSON.parse(versionStr) : null;
  } catch (error) {
    console.error('로컬 버전 정보 읽기 오류:', error);
    return null;
  }
}

/**
 * 로컬 스토리지에 버전 정보 저장
 */
export function setLocalVersion(versionInfo) {
  try {
    localStorage.setItem(VERSION_STORAGE_KEY, JSON.stringify(versionInfo));
  } catch (error) {
    console.error('로컬 버전 정보 저장 오류:', error);
  }
}

/**
 * 서버에서 최신 버전 정보 가져오기
 */
export async function fetchServerVersion() {
  try {
    // 캐시 방지를 위해 타임스탬프 추가
    const response = await fetch(`/version.json?t=${Date.now()}`, {
      cache: 'no-cache',
      headers: {
        'Cache-Control': 'no-cache',
        'Pragma': 'no-cache'
      }
    });
    
    if (!response.ok) {
      throw new Error('버전 정보 가져오기 실패');
    }
    
    return await response.json();
  } catch (error) {
    console.error('서버 버전 체크 오류:', error);
    return null;
  }
}

/**
 * 버전이 다른지 확인
 */
export function isVersionDifferent(localVersion, serverVersion) {
  if (!localVersion || !serverVersion) {
    return false;
  }
  
  // 빌드 타임스탬프로 비교 (더 정확함)
  if (localVersion.buildTimestamp && serverVersion.buildTimestamp) {
    return localVersion.buildTimestamp !== serverVersion.buildTimestamp;
  }
  
  // 버전 문자열로 비교 (fallback)
  return localVersion.version !== serverVersion.version;
}

/**
 * 초기 버전 정보 설정
 */
export async function initializeVersion() {
  try {
    const serverVersion = await fetchServerVersion();
    if (serverVersion) {
      setLocalVersion(serverVersion);
    }
  } catch (error) {
    console.error('버전 초기화 오류:', error);
  }
}

/**
 * 버전 체크 수행
 * @returns {Promise<boolean>} 새 버전이 있으면 true
 */
export async function checkForNewVersion() {
  try {
    const localVersion = getLocalVersion();
    const serverVersion = await fetchServerVersion();
    
    if (!serverVersion) {
      return false;
    }
    
    // 로컬 버전이 없으면 현재 버전으로 설정
    if (!localVersion) {
      setLocalVersion(serverVersion);
      return false;
    }
    
    // 버전 비교
    if (isVersionDifferent(localVersion, serverVersion)) {
      console.log('새 버전 감지:', {
        현재: localVersion,
        최신: serverVersion
      });
      return true;
    }
    
    return false;
  } catch (error) {
    console.error('버전 체크 오류:', error);
    return false;
  }
}

/**
 * 페이지 새로고침
 */
export function reloadPage() {
  window.location.reload();
}

export { VERSION_CHECK_INTERVAL };



